import type { ReactElement, ReactNode } from 'react';

import { AngleDownIcon } from '@bestseller-bit/frontend-community.theme.buying-theme';
import IconButton from '@mui/material/IconButton';

interface ExpandRowButtonProps {
    isExpanded: boolean;
    onClick?: () => void;
    icon?: ReactNode;
    className?: string;
}

const ExpandRowButton = ({
    isExpanded,
    onClick,
    icon = <AngleDownIcon size="20" />,
    className,
}: ExpandRowButtonProps): ReactElement => (
    <IconButton
        variant="text"
        sx={{
            // Custom designed icon button
            padding: 1,
            border: 'none',

            ['svg']: {
                // Resetting the icon size here until we update the design system
                width: '20px',
                height: '20px',
            },
        }}
        className={className}
        onClick={() => {
            onClick?.();
        }}
        {...(!onClick && {
            tabIndex: -1,
            role: 'none',
        })}
    >
        <div
            style={{
                rotate: isExpanded ? '180deg' : '0deg',
                transition: 'rotate 0.2s ease-in-out',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            {icon}
        </div>
    </IconButton>
);

export { ExpandRowButton };
